(() => {
  angular.module('app').component('hostCorporatesCreateEditFinance', {
    templateUrl: require('./widget.html'),
    controller: CorporateEditFinanceController,
    controllerAs: 'vm',
    require: {
      container: '^hostCorporatesCreateEditContainer',
    },
    bindings: {
      data: '<',
      currencyCode: '<',
      countryCode: '<',
      paymentMode: '<',
      billingAddress: '<',
      accountOwnerId: '<',
    },
  });

  CorporateEditFinanceController.$inject = [
    '$scope',
    'abp.services.app.corporate',
    'abp.services.app.commonLookup',
    'abp.services.finance.commonLookup',
    'Hms.AccountOwners.PaymentAccountNumberMode',
    'Hms.MultiTenancy.CollateralType',
    'Hms.MultiTenancy.TenantVirtualAccountGenerationMode',
    'Hms.MultiTenancy.TenantBillingAccountMode',
    'Hms.PaymentAccounts.PaymentAccount',
    'Hms.MultiTenancy.Tenant',
    'Hms.Finance.KnownBillingAccountType',
  ];

  function CorporateEditFinanceController(
    $scope,
    corporateSvc,
    commonLookupSvc,
    financeCommonLookupSvc,
    enumPaymentAccountNumberMode,
    enumCollateralType,
    enumTenantVirtualAccountGenerationMode,
    enumTenantBillingAccountMode,
    constsPaymentAccount,
    constsTenant,
    enumFinanceKnownBillingAccountType
  ) {
    const vm = this;
    vm.constsPaymentAccount = constsPaymentAccount;
    vm.constsTenant = constsTenant;
    vm.loading = 0;
    vm.saving = 0;
    vm.isCreate = false;
    vm.isEditing = false;
    vm.linkBillingAccountTooltip = App.localize('LinkPreexistingBillingAccountNarrative');

    vm.enums = {
      knownBillingAccountType: enumFinanceKnownBillingAccountType,
    };
    vm.enums.paymentAccountNumberMode = enumPaymentAccountNumberMode;
    vm.enums.collateralType = enumCollateralType;
    vm.enums.tenantVirtualAccountGenerationMode = enumTenantVirtualAccountGenerationMode;
    vm.enums.tenantBillingAccountMode = enumTenantBillingAccountMode;

    // Default value

    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.hasRegionalSystemSupport = abp.setting.getBoolean('Hms.Feature.RegionalSystemSupport');

    // Off / Locked / On: Locked makes the old collateral and corporate limit fields read-only,
    // On hides them because the new Collateral tab owns them.
    const collateralAndCreditLimitState = abp.setting.get('Hms.Feature.CollateralAndCreditLimit');
    vm.isCollateralLocked = collateralAndCreditLimitState === 'Locked';
    vm.hasCollateralAndCreditLimit = collateralAndCreditLimitState === 'On';

    vm.countryCode = 'MY';
    vm.paymentMode = null;
    vm.billingAccountMode = vm.enums.tenantBillingAccountMode.MultiBillingAccount.id;
    vm.accountOwnerId = null;

    vm.panels = [];

    vm.permissions = {
      advanceView: abp.auth.isGranted('Host.Corporates.Advance'),
      editFinance: abp.auth.isGranted('Host.Corporates.Edit.Finance'),
      create: abp.auth.isGranted('Host.Corporates.Create'),
      override: abp.auth.isGranted('Host.Corporates.Override'),
    };

    let currentSearch = '';

    vm.isDirty = isDirty;
    vm.setPristine = setPristine;
    vm.validateForm = validateForm;
    vm.clearCollateralRenewDate = clearCollateralRenewDate;
    vm.clearContractRenewDate = clearContractRenewDate;
    vm.getPayload = getPayload;
    vm.lookupPanels = lookupPanels;
    vm.lookupBillingAccount = lookupBillingAccount;
    vm.setBillingDetails = setBillingDetails;
    vm.save = save;
    vm.$onChanges = onChanges;
    vm.$onInit = init;

    function init() {
      vm.container.addWidget(this);
      getBanks();
      getBankAccountDetails();
      lookupBillingAccount();
    }

    function isDirty() {
      return $scope.corporateCreateEditFinanceForm && $scope.corporateCreateEditFinanceForm.$dirty;
    }

    function setPristine() {
      $scope.corporateCreateEditFinanceForm.$setPristine();
    }

    function getBanks() {
      vm.loading += 1;
      commonLookupSvc
        .getBanks()
        .success((data) => {
          vm.banks = data.items;
        })
        .finally(() => {
          getBanksByCountryCode();
          vm.loading -= 1;
        });
    }

    function getBanksByCountryCode() {
      vm.banksByCountryCode = _.filter(vm.banks, (b) => b.countryCode === vm.countryCode);
    }

    function getBankAccountDetails() {
      if (vm.accountOwnerId) {
        vm.loading += 1;

        corporateSvc
          .getReceivableBankAccounts({ accountOwnerId: vm.accountOwnerId })
          .success((data) => {
            vm.bankAccounts = data.items;
          })
          .finally(() => {
            vm.loading -= 1;
          });
      }
    }

    // Force validation on this form.
    // True if valid, otherwise, false.

    function validateForm(error) {
      const form = $scope.corporateCreateEditFinanceForm;
      App.touchFormErrors(form);
      error = !form.$valid;
    }

    function clearCollateralRenewDate() {
      vm.data.collateralRenewDate = null;
    }

    function clearContractRenewDate() {
      vm.data.contractRenewDate = null;
    }

    // Generate the payload from this form to send to CorporateAppService API.

    function getPayload(settings) {
      const payload = {
        finance: vm.data,
      };

      // Update panels that bypass corporate limit

      vm.data.bypassCorporateLimitPanelIds = _.map(
        vm.data.bypassCorporateLimitPanels,
        (d) => d.value
      );

      _.extend(settings, payload);
    }

    function lookupPanels(search) {
      currentSearch = search;
      if (search) {
        const excludedPanelIds = _.map(vm.data.bypassCorporateLimitPanels, (r) => r.value);
        corporateSvc
          .findPanels({
            filter: search,
            maxResultCount: 50,
            excludedPanelIds,
          })
          .success((data) => {
            if (search === currentSearch) {
              vm.panels = data.items;
            }
          });
      }
    }

    function lookupBillingAccount(search, billingAccountId) {
      const keyword = _.trim(search || '');

      if (keyword.length > 0 && keyword.length < 2) return;

      vm.loading += 1;
      financeCommonLookupSvc
        .getBillingAccounts({
          filter: keyword,
          maxResultCount: 20,
          id: billingAccountId,
          type: 1, // Debtor.
          isTenantless: true,
        })
        .success((data) => {
          if (data) {
            vm.billingAccounts = data.items;
            if (billingAccountId) {
              vm.billingAccount = _.find(vm.billingAccounts, ['id', billingAccountId]);
            }
          }
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    // Populate billing details based on selected tenantless billing account

    function setBillingDetails(selectedBillingAccount) {
      if (selectedBillingAccount && vm.isCreate) {
        vm.container.updateBillingAddress(selectedBillingAccount.billingAddress);

        vm.data.billingAccountType =
          selectedBillingAccount.type === 1
            ? vm.enums.knownBillingAccountType.Debtor.id
            : vm.enums.knownBillingAccountType.Creditor.id;
      }
    }

    // Ask container to save this widget.

    function save() {
      vm.container.saveWidget(vm);
    }

    function onChanges(changes) {
      vm.isCreate = vm.data ? !vm.data.id : false;

      // Set default value to Multi Billing Account if no selection has been made.

      if (vm.data && vm.data.billingAccountMode == null)
        vm.data.billingAccountMode = vm.billingAccountMode;

      // Filter list of banks according to country code

      if (changes.countryCode) {
        getBanksByCountryCode();
      }

      if (changes.accountOwnerId) {
        getBankAccountDetails();
      }
    }
  }
})();
